import React from 'react';
import styles from './Photo.module.css';

export const Photo = ({ message, rotateSign }) => {
  return (
    <div
      style={{
        height: '65rem',
        transform: `rotate(${rotateSign}5deg)`,
      }}
      className={styles.photo}
      key={message.id}>
      <img src={message?.attachments[0].url} alt={''} />
    </div>
  );
};
